// src/hooks/useFetchTenderNotice.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../routes/config';
// import { BASE_URL } from '../routes/config'; // adjust path as needed


const useFetchTenderNotice = (endpoint, options = {}) => {
  // const [data, setPageData] = useState([]);
  const [getPageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/${endpoint}`, {
        auth_key: "xxxxx", // or use options.auth_key
        ...options.body,
      });

      if (res.status === 200 && res.data.suc > 0) {
        setPageData(res.data.msg);
      } else {
        setPageData([]);
      }
    } catch (error) {
      console.error(`Error fetching from ${endpoint}:`, error);
      setPageData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [endpoint]);

  return { getPageData, loading, refetch: fetchData };
};

export default useFetchTenderNotice;


